import styled from 'styled-components';

export const StyledText = styled.span`
  margin-left: 14px;
  font-size: 15px;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;

export const MemberCountBadge = styled.span`
  margin-left: auto;
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  line-height: 1.2;
  margin-right: 25px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    span:not(${MemberCountBadge}) {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
    svg {
      path {
        fill: ${({ theme }) => theme.color.brightTurquoise};
      }
    }
  }
`;
